import React from 'react'
import { Heading } from '@myxplor/ui'

const Empty = ({ children }) => {
  return (
  <div className="displayRecordList--wrapper">
    <Heading small>No Personnel</Heading>
    {children}
  </div>
)
}
export default Empty



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/empty.jsx